export default __webpack_public_path__ + "static/step_2_en-eba8428a7f8489357f5adbd7ae37ed0a.svg";